import { TvShopEntertainmentPack } from '../model/tv-shop-entertainment-pack';
import { OmapiIdsUtils } from '../shared/utils/omapi-ids/omapi-ids-utils';
var TvShopEntertainmentPackGroupFactory = /** @class */ (function () {
    function TvShopEntertainmentPackGroupFactory() {
    }
    TvShopEntertainmentPackGroupFactory.build = function (entertainmentPackGroups, entertainmentPacks) {
        return entertainmentPackGroups.map(function (entertainmentPackGroup) {
            var tvShopEntertainmentPack = new TvShopEntertainmentPack();
            tvShopEntertainmentPack.omapiId = entertainmentPackGroup.omapiId;
            tvShopEntertainmentPack.isGroupPack = true;
            tvShopEntertainmentPack.subscribed = entertainmentPackGroup.childPackOmapiIds.some(function (entertainmentPackOmapiId) {
                return entertainmentPacks.some(function (entertainmentPack) {
                    return (entertainmentPack.omapiId === entertainmentPackOmapiId && entertainmentPack.subscribed);
                });
            });
            tvShopEntertainmentPack.priceDetail = entertainmentPacks.find(function (entertainmentPack) {
                return entertainmentPack.omapiId === entertainmentPackGroup.defaultChildPackOmapiId;
            }).priceDetail;
            tvShopEntertainmentPack.childPacks = entertainmentPackGroup.childPackOmapiIds.map(function (omapiId) {
                return entertainmentPacks.find(function (entertainmentPack) {
                    return entertainmentPack.omapiId === omapiId;
                });
            });
            tvShopEntertainmentPack.showSubtitleInCarousel = entertainmentPackGroup.omapiId !== OmapiIdsUtils.DISNEY_PLUS_ID;
            return tvShopEntertainmentPack;
        });
    };
    return TvShopEntertainmentPackGroupFactory;
}());
export { TvShopEntertainmentPackGroupFactory };
